import React, { useEffect, useState } from "react"
import MissingImage from "@/public/images/image-missing.png"
import { getShortenedUrlwithGeneral, sanitizeUrl } from "@/utils/helper"
import { getConfig } from "@/constants/config"

const ProductSize = props => {
  const { comboSkuDetails, i18n, authorData, productCategoryType } = props
  const [general, setGeneral] = useState({})
  const allowMaxSize = 3

  useEffect(() => {
    const configFn = async () => {
      const { general } = await getConfig()
      setGeneral(general)
    }
    configFn()
  }, [])

  const plpPagePath = getShortenedUrlwithGeneral(
    general.plpPagePath ?? "/",
    general
  )

  const handleProductSelect = selectedProductSize => {
    const selectedindex = comboSkuDetails.findIndex(obj => {
      return obj.ProductSize_ss === selectedProductSize
    })
    if (selectedProductSize) {
      const selectedProduct = comboSkuDetails[selectedindex]
      const newUrl = `${plpPagePath}/${productCategoryType.toLowerCase()}/${
        selectedProduct.slug_s
      }.html?skuId=${selectedProduct.sku_s}`
      window.history.replaceState({}, "", newUrl)
      window.location.reload(true)
    }
  }
  return (
    <>
      {comboSkuDetails && comboSkuDetails.length > 0 && (
        <div className={"product-size"}>
          <h3 className="title">
            <span className="lable">
              {authorData && authorData.sizeShapeDesign
                ? authorData.sizeShapeDesign
                : i18n.size}
              :
            </span>
            <span className="info">
              {comboSkuDetails &&
                comboSkuDetails.length > 0 &&
                comboSkuDetails.map(item =>
                  item.selected_b && item.selected_b === true
                    ? item.ProductGroupDescription_s
                    : ""
                )}
            </span>
          </h3>
          <div
            className={
              comboSkuDetails.length > allowMaxSize
                ? "size-row scroll"
                : "size-row"
            }
          >
            {comboSkuDetails.map((item, index) => {
              const ProductGroupSwatch = item.ProductGroupSwatch_s
                ? sanitizeUrl(`${props.swatchUrl}` + item.ProductGroupSwatch_s)
                : MissingImage
              return (
                <div
                  className={`size-column ${
                    item.selected_b && item.selected_b === true ? "active" : ""
                  }`}
                  key={`size-${index}`}
                >
                  <div
                    onClick={() => handleProductSelect(item.ProductSize_ss)}
                    className="size-swatch"
                  >
                    <img
                      onError={e => (e.target.src = MissingImage)}
                      src={ProductGroupSwatch}
                      className="img"
                    />
                  </div>
                  <p className="desc">{item.ProductGroupDescription_s}</p>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}

export default ProductSize
